import React, { useState } from 'react';

export default function StepComment({ form, handleChange, next, prev }) {
  const [opened, setOpened] = useState(false);
  const commentUrl = 'https://x.com/intent/post?in_reply_to=2059373002631098666&text=';

  const isValidUrl = (url) => url && /^https?:\/\/x\.com\/.+/i.test(url);
  const isValid = isValidUrl(form.proofOfComment);

  const inputStyle = {
    width: '100%', padding: '14px 16px',
    background: '#FFF9EE',
    border: `3px solid ${!form.proofOfComment || isValid ? '#3D1F0A' : '#B33000'}`,
    borderRadius: '12px',
    color: '#3D1F0A', fontSize: '14px',
    fontFamily: "'Nunito', sans-serif", fontWeight: '700',
    marginBottom: '8px', outline: 'none', boxSizing: 'border-box',
    boxShadow: 'inset 0 2px 5px rgba(61,31,10,0.08)',
    transition: 'border-color 0.2s',
  };

  return (
    <div>
      <h2 style={{ fontFamily: "'Bangers', cursive", fontSize: '26px', letterSpacing: '1.5px', color: '#3D1F0A', textAlign: 'center', marginBottom: '4px' }}>
        COMMENT ON THE TWEET
      </h2>
      <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '13px', color: '#6B4A1A', textAlign: 'center', marginBottom: '16px' }}>
        Drop a comment on the tweet, then paste the link below
      </p>

      {/* Comment task button */}
      <div
        className="wl-task-row"
        onClick={() => { window.open(commentUrl, '_blank', 'noopener,noreferrer'); setOpened(true); }}
        style={{
          display: 'flex', alignItems: 'center', padding: '10px 12px',
          background: opened ? 'rgba(200,116,0,0.12)' : '#FFF9EE',
          borderRadius: '12px',
          border: opened ? '2px solid rgba(200,116,0,0.4)' : '2px solid rgba(61,31,10,0.15)',
          cursor: 'pointer', marginBottom: '16px',
          boxShadow: '0 2px 8px rgba(61,31,10,0.08)', transition: 'all 0.2s ease',
        }}
      >
        <div style={{
          width: '24px', height: '24px', borderRadius: '6px', flexShrink: 0,
          border: '2px solid #3D1F0A', marginRight: '10px',
          background: opened ? 'linear-gradient(160deg, #C87400, #D4A017)' : 'transparent',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          {opened && <span style={{ color: '#F5EDD6', fontSize: '14px', fontWeight: '900' }}>✓</span>}
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontFamily: "'Bangers', cursive", fontSize: '13px', color: '#3D1F0A' }}>OPEN COMMENT ON X</div>
          <div style={{ fontFamily: "'Nunito', sans-serif", fontSize: '10px', color: '#8B6914' }}>Opens a reply to the pinned tweet</div>
        </div>
        <div style={{
          padding: '5px 10px', borderRadius: '8px',
          border: '2px solid #3D1F0A',
          background: opened ? 'linear-gradient(160deg, #C87400, #A85E00)' : 'rgba(61,31,10,0.06)',
          color: opened ? '#F5EDD6' : '#3D1F0A',
          fontFamily: "'Bangers', cursive", fontSize: '11px', letterSpacing: '0.5px',
        }}>
          {opened ? 'DONE ✓' : 'OPEN ↗'}
        </div>
      </div>

      <label style={{ fontFamily: "'Bangers', cursive", fontSize: '13px', letterSpacing: '1px', color: '#3D1F0A', display: 'block', marginBottom: '6px' }}>
        PASTE YOUR COMMENT URL
      </label>
      <input
        className="wl-input"
        name="proofOfComment"
        placeholder="https://x.com/yourhandle/status/..."
        value={form.proofOfComment}
        onChange={handleChange}
        style={inputStyle}
      />
      {form.proofOfComment && !isValid && (
        <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '12px', color: '#B33000', fontWeight: '800', marginBottom: '10px' }}>
          ⚠ Must be an x.com URL (e.g. https://x.com/...)
        </p>
      )}

      <div style={{ display: 'flex', gap: '10px', marginTop: '14px' }}>
        <button className="wl-btn-back" onClick={prev} style={{
          flex: 1, padding: '13px',
          background: '#FFF9EE', border: '2px solid #3D1F0A', borderRadius: '10px',
          color: '#3D1F0A', fontFamily: "'Bangers', cursive", fontSize: '15px', letterSpacing: '1px',
          cursor: 'pointer', boxShadow: '0 4px 0 #7A4A00', transition: 'all 0.1s ease',
        }}>← BACK</button>
        <button className="wl-btn-primary" onClick={next} disabled={!isValid} style={{
          flex: 2, padding: '13px',
          background: isValid ? 'linear-gradient(160deg, #C87400, #A85E00)' : 'rgba(61,31,10,0.15)',
          border: '3px solid #3D1F0A', borderRadius: '10px',
          color: isValid ? '#F5EDD6' : '#8B6914',
          fontFamily: "'Bangers', cursive", fontSize: '17px', letterSpacing: '2px',
          cursor: isValid ? 'pointer' : 'not-allowed',
          transform: isValid ? 'skewX(-4deg)' : 'none',
          boxShadow: isValid ? '0 5px 0 #7A4A00' : 'none',
          opacity: isValid ? 1 : 0.55, transition: 'all 0.12s ease',
        }}>
          <span style={{ display: 'inline-block', transform: isValid ? 'skewX(4deg)' : 'none' }}>CONTINUE →</span>
        </button>
      </div>
    </div>
  );
}
